(() => {
  const SELECTOR = '[data-black-friday26-banner]';

  const boot = (scope) => {
    (scope || document).querySelectorAll(SELECTOR).forEach((root) => {
      if (root.dataset.ready || !window.Splide) return;
      const el = root.querySelector('.black-friday26-banner__splide');
      const count = el ? el.querySelectorAll('.splide__slide').length : 0;
      if (count === 0) return;
      root.dataset.ready = 'true';
      root._splide = new window.Splide(el, {
        type: 'fade',
        rewind: true,
        speed: Number(root.dataset.speed || 800),
        arrows: false,
        pagination: count > 1,
        drag: count > 1,
        autoplay: root.dataset.autoplay === 'true',
        interval: Number(root.dataset.interval || 5000),
        pauseOnHover: true,
        pauseOnFocus: true,
        autoHeight: true
      }).mount();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => boot(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(SELECTOR).forEach((root) => {
      if (root._splide) root._splide.destroy(true);
    });
  });
})();
